/**
 * Generated by orval 🍺
 * Do not edit manually.
 * [DEV] Backend
 * OpenAPI spec version: 0.1.0
 */

export type FilterNegativeUserIntentV2Kind =
  (typeof FilterNegativeUserIntentV2Kind)[keyof typeof FilterNegativeUserIntentV2Kind];

export const FilterNegativeUserIntentV2Kind = {
  negative_user_intent_v2: 'negative_user_intent_v2',
} as const;
